<template>
  <v-card v-if="showApplicationsList" flat>
    <h4 v-if="applications && applications.length" class="mt-3">{{$t('application.list')}}</h4>

    <p class="mt-4 mb-6">{{$t('application.list-warning')}}</p>

    <!-- Application List start here -->
    <v-expansion-panels>
      <v-expansion-panel
        v-for="(item, index) in applications"
        :key="index"
        :aria-label="$t('labels.existing-applications')"
      >
        <v-expansion-panel-header expand-icon="$sl-arrow-down">
          <div>
            <div class="header-title">{{explanedStateName(item)}}</div>
            <div
              class="header-sub-title"
            >{{$t('application.list-changed')}} {{ item.createdAt | date}}</div>
          </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content class="mb-2">
          <h6>{{$t('application.list-draft')}}</h6>
          <p>{{item.createdAt | date}}</p>
          <h6>{{$t('application.list-saved')}}</h6>
          <p>{{item.updatedAt | date}}</p>
          <template v-if="checkHasNotifications(item)">
            <h6 class="mb-1">{{$t('application.list-notification')}}</h6>
            <div v-for="notification in item.notifications" :key="notification.id">
              <div v-if="notification.text != ''">
                <p class="message-title">
                  {{ getNotification(notification)}}
                  <span
                    class="message-date"
                  >({{notification.sentTime | date}})</span>
                </p>
                <p v-html="notification.text"></p>
              </div>
            </div>
          </template>
          <div v-if="(item.companyId>0 && isCompanyUser(item.companyId)) && currentUser.personalNumber != item.personalNumber">
            <ActionButton
              type="application"
              actionIcon="$sl-arrow-right"
              :isDisabled="!(item.stateId === companyDraftStateId && item.isCompanyApplication) || isImitatingUser()"
              @click="$emit('open',{id: item.id, isCompany: true})"
            >{{$t('application.list-continueBtn')}}</ActionButton>
          </div>
          <div v-else>
            <ActionButton
              actionIcon="$sl-arrow-right"
              flat
              class="mt-3"
              :isDisabled="!(item.stateId == apprenticeDraftStateId || item.stateId == apprenticeDraftStateId && item.isCompanyApplication || item.stateId == confirmedByCompany) || isImitatingUser()"
              @click="$emit('open',{id: item.id, isCompany: false })"
              type="application"
            >{{$t('application.list-continueBtn')}}</ActionButton>
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>

    <!-- Application List ends here -->
  </v-card>
</template>

<script>
//Entryform for unknown user to become a apprentice
//
import API from '@/services/api.js'
import {mapGetters} from 'vuex'
import pickBy from 'lodash/pickBy'
const SugarDate = require('sugar/date')
import find from 'lodash/find'
import Lget from 'lodash/get'
import findIndex from 'lodash/findIndex'
import ActionButton from '@/components/Common/ActionButton'

// @group Applications/Common
// ApplicationCompanies component
export default {
  name: 'ApprenticeListApplications',

  props: {
    // The  Applications list
    applications: {
      // `'Array'`
      type: Array,
      // `'Array'`
      default: () => []
    },
    // Show application prop
    showApplicationsList: false
    // `'Boolean'` / `'false'`
  },
  components: {
    ActionButton
  },
  data: () => ({
    applicationID: -1,
    hasNotifications: false
  }),

  mounted() {
    this.$scrollToTop()
  },

  computed: {
    ...mapGetters('currentuser', ['currentUser', 'isApprentice', 'isInstructor', 'isCompanyUser', 'isImitatingUser']),
    ...mapGetters('application', ['currentStep']),
    ...mapGetters('basic', ['apprenticeDraftStateId', 'companyDraftStateId', 'basicProfessions', 'confirmedByCompany'])
  },

  created(){
  },

  methods: {
    explanedStateName(item) {
      const state = Lget(item, 'state.state', null)
      if (state=="basicEducationCertificateIssued") {
        return "Grundutbildning godkänd"
      }
      return Lget(item, 'state.name','')
    },
    /**
     * @vuese
     * Used to get inject html if notification from name and to name are the same
     * @arg The argument is an object representing notification
     */
    getNotification(notification) {
      var ret = ''
      if (notification.fromName && notification.fromName != '') {
        if (notification.fromName == notification.toName) {
          ret =
            this.$t('application.instructor.date.date-from') +
            ' BYN ' +
            this.$t('application.instructor.date.date-to2') +
            ' ' +
            notification.toName
        } else {
          ret = this.$t('application.instructor.date.date-from') + ' ' + notification.fromName

          if (notification.toName && notification.toName != '') {
            ret += ' ' + this.$t('application.instructor.date.date-to2') + ' ' + notification.toName
          }
        }
      } else if (notification.toName && notification.toName != '') {
        ret = this.$t('application.instructor.date.date-to') + ' ' + notification.toName
      }
      return ret
    },
    /**
     * @vuese
     * Used to return profession name based on profession id
     * @arg The argument is an integer representing profession id
     */
    /* professionName(id) {
      if (!id) {
        return ''
      }
      const p = find(this.basicProfessions, ['id', id])
      return p ? `- ${p.name}` : ''
    }, */
    /**
     * @vuese
     * We don't open signed applications etc

     */
    nada() {},
    /**
     * @vuese
     * Used to check if the application has messages and returm if any
     * @arg The argument is an object representing application
     */
    checkHasNotifications(item) {
      if (item && item.notifications && item.notifications.length > 0) {
        let result = find(item.notifications, o => o.text != '')
        if (result) {
          return true
        }
        return false
      }
      return false
    }
  }
}
</script>

<style scoped>
</style>
